import React, { useState, useEffect } from 'react';
import { Divider, Button, Form, Row, Col, Upload, Input, Image, notification } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { UploadOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import { sendData, sendDataPut } from '../../httpRequests';
import { getPharmacyId } from '../../components/Shared';

const { TextArea } = Input;

export default function AdminPharmacyDetails() {
	const navigate = useNavigate();
	const [pharmacy, setPharmacy] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [password, setPassword] = useState('');
	const [disabled, setDisabled] = useState(0);

	const { id } = useParams();

	useEffect(() => {
		if (id !== null) {
			loadPharmacy();
		}
		return () => {
			setPharmacy({});
		};
	}, []);

	const loadPharmacy = () => {
		const pharmacyId = getPharmacyId();
		console.log(pharmacyId)
		if (!pharmacyId) {
			navigate('/login');
			return false;
		}

		checkUserAdmin(pharmacyId);

		const url = '/pharmacies/getPharmacyById';
		const data = {
			id: id
		};
		sendData(url, data).then((response) => {
			if (Object.keys(response).length > 0) {
				const pharmacy = response['pharmacy'];
				console.log(pharmacy)

				const url = '/products/getProductsByPharmacyPanel';
				const data = { pharmacy_id: pharmacy.id };
				sendData(url, data).then((response) => {
					let allProducts = [];
					let activeProducts = [];
					if (Object.keys(response).length > 0) {
						const products = response['pharmacyproduct'];
						allProducts = products;
						activeProducts = products.filter((product) => product.status == 1);
					}
					pharmacy.products_count = allProducts.length;
					pharmacy.active_products_count = activeProducts.length;

					const url = '/orders/getAllOrdersByPharmacy';
					const data = {
						pharmacy_id: pharmacy.id
					};
					sendData(url, data).then((response) => {
						let allOrders = [];
						if (Object.keys(response).length > 0) {
							const orders = response['order'];
							allOrders = orders;
						}
						pharmacy.orders_count = allOrders.length;
						setPharmacy(pharmacy);
						setDisabled(pharmacy.disabled)
					});
				});
			}
		});
	};

	const checkUserAdmin = (pharmacyId) => {
		const url = '/pharmacies/getPharmacyById';
		const data = {
			id: pharmacyId
		};
		sendData(url, data).then((response) => {
			const pharmacy = response['pharmacy'];
			if (pharmacy.role_id != 4 && pharmacy.role_id != 5) navigate('/orders');
		});

		return false;
	};

	const validateFile = ({ file, onSuccess, onError }) => {
		if (['image/png', 'image/jpeg'].includes(file.type) && file.size <= 2097152) {
			onSuccess(true);
			uploadPharmacyPicture(file);
		} else onError(true);
	};

	const uploadPharmacyPicture = (profilePicture) => {
		let formData = new FormData();
		formData.append('image', profilePicture);

		const url = '/pharmacies/updatePharmacyPhoto/' + pharmacy.id;

		sendDataPut(url, formData).then((response) => {
			if (Object.keys(response).length > 0) {
				window.location.reload();
			}
		});
	};

	const updatePharmacyProfile = (values) => {
		setIsLoading(true);

		const url = '/pharmacies/updatePharmacy';
		const data = {
			id: pharmacy.id,
			email: values.email,
			npi: pharmacy.npi,
			secret_key: values.secret_key,
			name: values.name,
			address: values.address,
			city: values.city,
			phone: values.phone,
			zip: values.zip,
			account_name: values.account_name,
			bank_account: values.bank_account,
			banking_institute: values.banking_institute,
			route_number: values.route_number,
			driver_status: pharmacy.driver_status,
			dispatcher: values.dispatcher,
			placeOfDispatch: values.placeOfDispatch,
			dispatcherPhone: values.dispatcherPhone
		};
		console.log(data)
		sendData(url, data).then((response) => {
			setIsLoading(false);
			if (Object.keys(response).length > 0) {
				Swal.fire({
					text: response['message'],
					icon: 'success',
					confirmButtonColor: '#128780'
				}).then(() => window.location.reload());
			}
		});
	};

	const resetPharmacyPassword = () => {
		const url = '/pharmacies/updatedPasswordPharmacy';
		const data = {
			id: pharmacy.id,
			password: password
		};
		sendDataPut(url, data).then((response) => {
			setIsLoading(false);
			if (Object.keys(response).length > 0) {
				console.log(response);
				Swal.fire({
					text: response['menssage'],
					icon: 'success',
					confirmButtonColor: '#128780'
				}).then(() => window.location.reload());
			}
		});
	};

	const disablePharmacy = (id) => {
		const url = `/pharmacies/enableDisblePharmacy`
		sendData(url, { id, value: disabled }).then((response) => {
			if (response.ok) {
				setDisabled(!disabled)
				if (disabled) {
					notification['success']({
						description: "Pharmacy disabled successfully"
					});
				} else {
					notification['success']({
						description: "Pharmacy enable successfully"
					});
				}
			}
		});
	}

	return (
		<div>
			{Object.keys(pharmacy).length > 0 && (
				<Form layout='vertical' onFinish={updatePharmacyProfile}>
					<div>
						<h2 style={{ marginBottom: 30 }}>Pharmacy statistics</h2>
						<Row gutter={24}>
							<Col span={3}>
								<h3>Total orders:</h3>
								<span className='ant-form-text'>{pharmacy.orders_count} orders</span>
							</Col>
							<Col span={3}>
								<h3>Total products:</h3>
								<span className='ant-form-text'>{pharmacy.products_count} products</span>
							</Col>
							<Col span={3}>
								<h3>Total active products:</h3>
								<span className='ant-form-text'>{pharmacy.active_products_count} products</span>
							</Col>
							<Col span={5}>
								<h3>Products:</h3>
								<Button
									type='primary'
									style={{ borderRadius: 10 }}
									size='large'
									onClick={() => navigate('/admin/pharmacyProducts/' + pharmacy.id)}
								>
									Show products
								</Button>
							</Col>
							<Col span={5}>
								<h3>Categories:</h3>
								<Button
									type='primary'
									style={{ borderRadius: 10 }}
									size='large'
									onClick={() => navigate('/admin/pharmacyCategories/' + pharmacy.id)}
								>
									Show categories
								</Button>
							</Col>
							<Col span={5}>
								<h3>Pharmacy Status:</h3>
								{(disabled) ? <Button
									type='danger'
									style={{ borderRadius: 10 }}
									size='large'
									onClick={() => { disablePharmacy(pharmacy.id) }}
								>
									Enable
								</Button>
									: <Button
										type='primary'
										style={{ borderRadius: 10 }}
										size='large'
										onClick={() => { disablePharmacy(pharmacy.id) }}
									>
										Disable
									</Button>}
							</Col>

						</Row>
						<Divider />
						<h2 style={{ marginBottom: 30 }}>Contact information</h2>
						<Row style={{ marginBottom: 20 }}>
							<Col span={12}>
								<Form.Item label='Profile picture' valuePropName='file'>
									<Upload maxCount={1} listType='picture' customRequest={validateFile}>
										<Button icon={<UploadOutlined />}>Upload Profile Picture</Button>
									</Upload>
								</Form.Item>
								<Image
									src={
										pharmacy.img != null
											? pharmacy.img
											: require('../../assets/images/profile_avatar.png')
									}
									height={100}
									width={100}
								/>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.email}
									label='Email'
									name='email'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='email' autoCapitalize='false' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.name}
									label='Name'
									name='name'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.phone}
									label='Phone'
									name='phone'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='phone' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.address}
									label='Address'
									name='address'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='address' />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.zip}
									label='Zip Code'
									name='zip'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.city}
									label='City'
									name='city'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.secret_key}
									label='Secret key'
									name='secret_key'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.npi}
									label='NPI'
									name='npi'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.security_code}
									label='Security code'
									name='security_code'
								>
									<Input size='large' type='text' disabled />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.bank_account}
									label='Bank account'
									name='bank_account'
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.banking_institute}
									label='Banking institute'
									name='banking_institute'
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.account_name}
									label='Account name'
									name='account_name'
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.route_number}
									label='Route number'
									name='route_number'
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.dispatcher}
									label='Dispatcher contact name'
									name='dispatcher'
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.dispatcherPhone}
									label='Dispatcher extension number'
									name='dispatcherPhone'
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.placeOfDispatch}
									label='Place of dispatch'
									name='placeOfDispatch'
								>
									<TextArea rows={4} />
								</Form.Item>
							</Col>
						</Row>
					</div>
					<Divider />
					<div>
						<h2 style={{ marginBottom: 30 }}>Security</h2>
						<Row gutter={24}>
							<Col span={6}>
								<span>Password</span>
								<Input size='large' type='text' onChange={(event) => setPassword(event.target.value)} />
							</Col>
							<Col span={5} style={{ display: 'flex', alignItems: 'flex-end' }}>
								<Button
									onClick={() => resetPharmacyPassword()}
									type='primary'
									danger={true}
									style={{ borderRadius: 10 }}
									size='large'
								>
									Reset Password
								</Button>
							</Col>
						</Row>
					</div>
					<Row gutter={24} style={{ marginTop: 50 }}>
						<Col span={24}>
							<Form.Item>
								<Button
									type='primary'
									htmlType='submit'
									loading={isLoading}
									disabled={isLoading}
									style={{ borderRadius: 10, width: '100%', backgroundColor: '#128780' }}
									size='large'
								>
									Save changes
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			)}
		</div>
	);
}
